module.exports = __webpack_public_path__ + "img/signInBtn.1f5e008d.png";